import React from 'react';
import { clsx } from 'clsx';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'white' | 'blush' | 'outline';
}
export function Card({
  children,
  className,
  variant = 'white'
}: CardProps) {
  const variants = {
    white: 'bg-white shadow-sm border border-brand-primary/20',
    blush: 'bg-brand-secondary/20 border border-brand-secondary/30',
    outline: 'bg-transparent border border-brand-primary/25'
  };
  return <div className={clsx('rounded-2xl p-6 md:p-8', variants[variant], className)} data-id="element-282">
      {children}
    </div>;
}